import { motion } from "framer-motion";
import { Eye, Target } from "lucide-react";

export default function VisionMission() {
  return (
    <section id="vision" data-testid="vision-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={`data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%230F172A%22%2F%3E%3C/svg%3E`}
          alt="Elegant event"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F172A]/90 via-[#0F172A]/80 to-[#2563EB]/60" />
      </div>

      <div className="relative pz-container text-white">
        <div className="max-w-3xl">
          <span className="pz-overline" style={{ color: "#F59E0B" }}>Vision &amp; Mission</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Building lasting impressions —<br />one brand at a time.
          </h2>
          <div className="pz-gold-line mt-6" />
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-7">
          {[
            {
              icon: Eye,
              tag: "Our Vision",
              text:
                "To become a trusted name in branding, printing and event solutions by consistently delivering quality-driven and creative services.",
            },
            {
              icon: Target,
              tag: "Our Mission",
              text:
                "To support businesses with reliable printing, gifting and event solutions that strengthen brand presence and create lasting impressions.",
            },
          ].map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.tag}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.15 }}
                data-testid={`vm-card-${i}`}
                className="pz-glass-dark rounded-3xl p-9"
              >
                <div className="w-14 h-14 rounded-2xl bg-[#F59E0B] text-[#0F172A] flex items-center justify-center">
                  <Icon className="w-7 h-7" strokeWidth={1.6} />
                </div>
                <div className="mt-7 text-[11px] uppercase tracking-[0.22em] text-[#F59E0B] font-semibold">{card.tag}</div>
                <p className="mt-3 font-display text-2xl sm:text-3xl leading-snug font-medium">
                  &ldquo;{card.text}&rdquo;
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
